(() => {
 const menus=new Map();
 function init(root){
  if(menus.has(root))return;
  let opened=false,lastOpener=null,resetTimer=null;
  const panels=[...root.querySelectorAll('[data-lm-panel]')],scroll=root.querySelector('.lm-scroll'),home=panels[0],close=root.querySelector('.lm-close');
  function show(id,focus=true){
   const panel=panels.find(p=>p.id===id);if(!panel)return;
   panels.forEach(p=>p.hidden=p!==panel);
   root.querySelectorAll('[data-lm-open]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.lmOpen===id)));
   scroll.scrollTop=0;if(focus)panel.querySelector('button,a')?.focus({preventScroll:true});
  }
  function sync(){
   if(innerWidth>=1200&&document.body.classList.contains('nav-open'))document.body.classList.remove('nav-open');
   const active=document.body.classList.contains('nav-open')&&innerWidth<1200;
   root.inert=!active;root.setAttribute('aria-hidden',String(!active));
   document.querySelectorAll('.top-header .navbar-toggler').forEach(b=>b.setAttribute('aria-expanded',String(active)));
   if(active&&!opened){clearTimeout(resetTimer);lastOpener=document.activeElement;show(home.id,false);close.focus({preventScroll:true});}
   if(!active&&opened){resetTimer=setTimeout(()=>{if(!opened)show(home.id,false);},300);lastOpener?.focus?.({preventScroll:true});}
   opened=active;
  }
  function click(e){const b=e.target.closest('[data-lm-open]');if(b){e.preventDefault();show(b.dataset.lmOpen);}}
  function key(e){
   if(!opened)return;
   if(e.key==='Escape'){e.preventDefault();e.stopPropagation();close.click();return;}
   if(e.key!=='Tab')return;
   const focusable=[...root.querySelectorAll('a[href],button,input:not([type="hidden"])')].filter(e=>!e.closest('[hidden]')&&e.getClientRects().length);
   const first=focusable[0],last=focusable.at(-1);
   if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
   else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
  }
  const observer=new MutationObserver(sync);observer.observe(document.body,{attributes:true,attributeFilter:['class']});
  root.addEventListener('click',click);root.addEventListener('keydown',key);addEventListener('resize',sync);sync();
  menus.set(root,()=>{clearTimeout(resetTimer);observer.disconnect();root.removeEventListener('click',click);root.removeEventListener('keydown',key);removeEventListener('resize',sync);menus.delete(root);});
 }
 function scan(scope=document){scope.querySelectorAll('[data-lenotos-mobile-menu]').forEach(init);}
 scan();document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-lenotos-mobile-menu]').forEach(r=>menus.get(r)?.()));
})();
